module.exports = __webpack_public_path__ + "static/media/YF26_3.a959ccee.jpg";